import React from 'react';
import { motion } from 'framer-motion';
import {
    Package,
    HelpCircle,
    RefreshCw,
    Briefcase,
    Truck,
    Shield,
    Star,
    FileText
} from 'lucide-react';

const QuickHelpBit = ({ isMobile = false }) => {
    const quickOptions = [
        {
            icon: Package,
            title: "Track Your Order",
            description: "Monitor delivery status in real-time",
            color: "from-champagne/20 to-champagne/10",
            action: () => console.log('Track order')
        },
        {
            icon: HelpCircle,
            title: "FAQ & Help Center",
            description: "Find answers to common questions",
            color: "from-sage/20 to-sage/10",
            action: () => window.location.href = '/faq'
        },
        {
            icon: RefreshCw,
            title: "Returns & Exchanges",
            description: "30-day return policy, free shipping",
            color: "from-nude/20 to-nude/10",
            action: () => console.log('Returns')
        },
        {
            icon: Briefcase,
            title: "Business Inquiries",
            description: "Wholesale, partnerships, and press",
            color: "from-champagne/10 to-transparent",
            action: () => console.log('Business')
        },
        {
            icon: Truck,
            title: "Shipping Information",
            description: "Delivery times and tracking",
            color: "from-sage/10 to-transparent",
            action: () => console.log('Shipping')
        },
        {
            icon: Shield,
            title: "Product Safety",
            description: "Ingredients and dermatological testing",
            color: "from-nude/10 to-transparent",
            action: () => console.log('Safety')
        },
        {
            icon: Star,
            title: "Product Reviews",
            description: "Read verified customer experiences",
            color: "from-champagne/5 to-transparent",
            action: () => console.log('Reviews')
        },
        {
            icon: FileText,
            title: "Order History",
            description: "View past orders and receipts",
            color: "from-sage/5 to-transparent",
            action: () => console.log('History')
        }
    ];

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="luxury-card p-4 md:p-6"
        >
            <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-champagne/20 to-sage/20 flex items-center justify-center">
                    <HelpCircle className="w-5 h-5 text-champagne" />
                </div>
                <div>
                    <h2 className="font-heading text-xl md:text-2xl font-medium text-charcoal">
                        Quick Support
                    </h2>
                    <p className="text-sm text-charcoal/50">
                        Find instant answers to common questions
                    </p>
                </div>
            </div>

            <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-2'} gap-3`}>
                {quickOptions.map((option, index) => (
                    <motion.button
                        key={option.title}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.05 }}
                        whileHover={{ y: -2 }}
                        onClick={option.action}
                        className={`p-3 md:p-4 rounded-xl text-left transition-all duration-300 hover:shadow-md bg-gradient-to-r ${option.color}`}
                    >
                        <div className="flex items-start gap-3">
                            <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                                <option.icon className="w-4 h-4 md:w-5 md:h-5 text-champagne" />
                            </div>
                            <div>
                                <h3 className="font-medium text-charcoal text-sm md:text-base mb-1">
                                    {option.title}
                                </h3>
                                <p className="text-xs text-charcoal/50">{option.description}</p>
                            </div>
                        </div>
                    </motion.button>
                ))}
            </div>

            {/* Support Note */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3 }}
                className="mt-6 pt-6 border-t border-nude/30"
            >
                <p className="text-sm text-charcoal/60 text-center">
                    Can't find what you're looking for?<br />
                    Our beauty advisors are always here to help.
                </p>
            </motion.div>
        </motion.div>
    );
};

export default QuickHelpBit;